import { Button, Stack, Flex, Box } from '@mantine/core';
import { IconCirclePlus, IconTrash } from '@tabler/icons-react';
import { CustomInput } from '../../CustomInput';

export const AddRemoveItemList = ({
  items,
  inputLabel,
  inputValue,
  onInputChange,
  onAddItem,
  onRemoveItem,
  renderItem,
  addButtonDisabled,
}: {
  items: any[];
  inputLabel: string;
  inputValue: string;
  onInputChange: (value: string) => void;
  onAddItem: () => void;
  onRemoveItem: (index: number) => void;
  renderItem?: (item: any, index: number) => React.ReactNode;
  addButtonDisabled?: boolean;
}) => (
  <Stack gap="md">
    <Flex gap="md" align="end">
      <Box style={{ flex: 1 }}>
        <CustomInput
          value={inputValue}
          name={inputLabel.toLowerCase().replace(/\s+/g, '')}
          label={inputLabel}
          type="text"
          onChange={(value) => onInputChange(value)}
        />
      </Box>
      <Button
        id={`add-item-button-${inputLabel.toLowerCase().replace(/\s+/g, '-')}`}
        variant="default"
        onClick={onAddItem}
        disabled={addButtonDisabled}
      >
        <IconCirclePlus size={16} />
      </Button>
    </Flex>
    {items && items.length > 0 && (
      <Stack gap="md">
        {items.map((item: any, index: number) => (
          <Flex key={index} gap="md" align="center" justify="space-between">
            {renderItem ? (
              renderItem(item, index)
            ) : (
              <Flex align="center">{item}</Flex>
            )}
            <Button
              id={`remove-item-button-${inputLabel.toLowerCase().replace(/\s+/g, '-')}-${index}`}
              variant="default"
              onClick={() => onRemoveItem(index)}
            >
              <IconTrash size={16} />
            </Button>
          </Flex>
        ))}
      </Stack>
    )}
  </Stack>
);
